export default {
  title: 'My Varo',
  agreements: {
    legalAndPrivacy: {
      title: 'Legal and privacy',
    },
  },
  notifications: {
    notificationSettings: {
      title: 'Notification settings',
      changesNotSavedMessage: 'Changes not saved. Please try again.',
    },
    bottomSheet: {
      title: 'Push notifications are disabled',
      subtitle:
        'Please go to your device settings to turn on push notifications for Varo.',
      buttons: {
        goToSystemSettings: 'Go to system settings',
        notRightNow: 'Not right now',
      },
    },
  },
  personalDetails: {
    title: 'Personal details',
    labels: {
      name: 'Name',
      homeAddress: 'Home address',
      homeAndMailingAddress: 'Home and mailing address',
      mailingAddress: 'Mailing address',
      phoneNumber: 'Phone number',
      emailAddress: 'Email address',
      security: 'Security',
      changePassword: 'Change password',
      faceId: 'Face ID',
      biometrics: 'Biometrics',
      chooseFromLibrary: 'Choose from library',
      takePhoto: 'Take photo',
    },
    dialog: {
      faceIDTitle: 'Face ID is disabled for Varo',
      biometricTitle: 'Biometric is disabled for Varo',
      faceIDMessage: 'Please go to your device settings to enable Face ID',
      biometricMessage: 'Please go to your device settings to enable Biometric',
      error: 'Error',
      errorMessage:
        'Varo is unable to set up Face ID/Biometric. Please check your device settings or try again later.',
      buttons: {
        cancel: 'Cancel',
        goToSettings: 'Go to settings',
        ok: 'Ok',
      },
    },
    alertDialog: {
      faceIDTitle: 'Face ID is not enrolled on this device',
      faceIDMessage: 'Please go to your system settings to enrolled Face ID',
      biometricTitle: 'Biometric is not enrolled on this device',
      biometricMessage:
        'Please go to your system settings to enrolled Biometric',
      error: 'Error',
      errorMessage:
        'Varo is unable to set up Face ID. Please check your device settings or try again later.',
      buttons: {
        cancel: 'Cancel',
        goToSettings: 'Go to settings',
        ok: 'Ok',
      },
    },
    buttons: {
      uploadPhoto: 'Upload photo',
    },
    errors: {
      phoneChangeFailed: {
        title: 'That link has expired',
        description:
          'We couldn’t save your changes. Try again to receive a new link.',
      },
      phoneChangeApiFailed: {
        title: 'We couldn’t process your changes',
        description:
          'There was an issue on our end, but we’re on it! Please try again.',
      },
      emailChangeFailed: {
        title: 'Invalid link',
        description:
          'The link you followed has expired and your changes could not be saved. Please try again.',
      },
    },
    snackbarMessages: {
      phoneChanged: 'Phone number successfully changed',
      emailChanged: 'Email successfully changed',
      homeAndMailingAddressSuccess:
        'Home and mailing address successfully changed',
      mailingAddressSuccess: 'Mailing address successfully changed',
      homeAddressSuccess: 'Home address successfully changed',
    },
    address: {
      header: 'Where should we send your card?',
      subHeader: 'Use your residential address. We can’t send to PO boxes.',
      textField: {
        addressLine1: 'Street address',
        addressLine2: 'Apt/Suite/Unit',
        city: 'City',
        state: 'State',
        zip: 'ZIP Code',
      },
      enterAddressManually: 'Enter address manually',
      buttons: {
        save: 'Save',
        saveAndContinue: 'Save and continue',
      },
    },
    changeAddress: {
      screenTitle: 'Home address',
      header: 'Which one would you like to use?',
      subHeader: 'We found an address that might work better with USPS.',
      radioTitles: {
        whatYouEntered: 'What you entered',
        suggested: 'Suggested',
      },
      buttons: {
        editAddress: 'Edit Address',
      },
      subParaText:
        'Your home address helps us verify your identity for when you apply for Varo products.',
      subParaTextHomeAndMailing:
        'Home address is where you live. Mailing address is where you get mail. They can be the same.',
      subParaTextMailing:
        'My mailing address is different from my home address.',
      mailingAddress: 'Mailing address',
    },
    changeMailingAddress: {
      screenTitle: 'Mailing address',
      header: 'Which one would you like to use?',
      subHeader: 'We found an address that might work better with USPS.',
      radioTitles: {
        whatYouEntered: 'What you entered',
        suggested: 'Suggested',
      },
      buttons: {
        editAddress: 'Edit Mailing Address',
      },
    },
    addressVerification: {
      homeAddressTitle: 'Double-check your home address',
      mailingAddressTitle: 'Double-check your mailing address',
      suggestedAddressTitle: 'We found a more accurate address',
      identicalAddressTitle: 'Is this correct?',
      identicalAddressMessage:
        'Select continue to confirm that your home and mailing addresses are the same.',
      homeAddress: 'Home address',
      mailingAddress: 'Mailing address',
      originalAddress: 'Original address',
      youEntered: 'You entered:',
      suggestedAddress: 'Suggested address:',
      addressReviewInfo:
        'The address you entered may be wrong or misspelled, please check again and edit any errors.',
      buttons: {
        editAddress: 'Edit address',
        editOriginal: 'Edit original',
        accept: 'Accept',
        continue: 'Continue',
        useSuggestedAddress: 'Use suggested address',
      },
    },
  },
  statementsAndForms: {
    title: 'Statements and documents',
    accountStatements: {
      title: 'Account statements',
      emptyStateBodyText:
        'You do not have any account statements at this time.',
    },
    payOverTimeStatements: {
      accountTitle: 'Pay Over Time Account',
      emptyStateBodyText:
        'You do not have any Pay Over Time statements at this time.',
      title: 'Pay Over Time statements',
    },
    closedAccounts: {
      title: 'Closed accounts',
    },
    taxStatements: {
      title: 'Tax statements',
      faqText: ' FAQ ',
      textBeforeFAQ:
        'You do not have any tax documents at this time. Please visit our',
      textAfterFAQ:
        'page to view the eligibility for receiving a 1099 tax document. If you believe you met the minimum requirements, please contact us via chat.',
    },
  },
  help: {
    title: 'Help and support',
    topics: {
      title: 'Popular topics',
    },
    callUs: {
      contactSupport: 'Contact support',
      contactDescription:
        'Reach out for dispute and mobile wallet support by calling our support team at:',
      contactNumber: '1-877-377-8276',
    },
    hoursOfOperation: 'Hours of operation',
  },
  // TODO: migrate all wallet strings to a proper home
  cardManagement: {
    walletProvisioningSuccess: {
      title: 'Your card was added to your wallet',
      buttonText: 'Got it',
    },
    manageCard: {
      error: {
        title: 'Oops! Something went wrong.',
        message: 'Please try again later',
        button: 'Okay',
        cardNumberError: 'Card details not available',
      },
      openAppleWallet: 'Open Apple Wallet',
      walletProvisioningErrorAlert: {
        error: 'Error',
        errorBody: "We're unable to add your card right now. Try again later.",
        okButton: 'Ok',
        googleWalletAppNotOpening: 'Unable to open your wallet app.',
      },
      walletErrorName: 'The operation couldn’t be completed.',
    },
  },
  confirmEmail: {
    title: 'Change email',
    screenTitle: 'Verify new email',
    description:
      'To finish updating your email, we need to verify your identity. We sent a link to {{emailId}}.',
    buttons: {
      done: 'Done',
      resend: 'Resend link',
      ok: 'Ok',
    },
    message: {
      sentLinkToMail: 'New link sent to your email',
    },
    dialog: {
      title: 'Too many attempts',
      message: `You’ve exceeded the number of verification code requests. Please try again later.`,
      buttons: {
        ok: 'Ok',
      },
    },
  },
  disputes: {
    title: 'Disputes',
    claimHash: 'Claim #',
    totalAmount: 'Total amount ({{numberOfCharges}}{{charge}}{{amount}})',
    charge: ' charge - ',
    charges: ' charges - ',

    buttons: {
      faq: 'FAQ',
      showMore: 'Show More',
    },
    noOpenDisputes: 'No open disputes',
    noClosedDisputes: 'No closed disputes',
    noClosedDisputesSecondaryText:
      'You do not have any closed disputes recently.',
    emptyStateTitle: 'File a dispute',
    emptyStateSubtitle: 'We offer dedicated support for disputes',
  },
  manageAccounts: {
    title: 'Manage accounts',
    titleTabapay: 'Manage cards and accounts',
    heading: 'Account management',
    accountNumbers: {
      title: 'Account numbers',
      checkingAccountHeading: 'Varo Bank Account',
      savingsAccountHeading: 'Varo Savings Account',
      accountNumber: 'Account number',
      routingNumber: 'Routing number',
      copyToClipBoard: 'Copied!',
      showAccountNumbers: 'Show account numbers',
      showAccountNumber: 'Show account number',
      manageDirectDeposit: 'Manage direct deposit',
      setupDirectDeposit: 'Set up direct deposit',
    },
  },
  enterCode: {
    title: {
      email: 'Change email',
      password: 'Change password',
    },
    buttons: {
      resend: 'Resend code',
      next: 'Next',
    },
    screenTitle: 'We sent you a text',
    description:
      'Enter the 6-digit code we sent to your phone number ending in {{1234}}.',
    errors: {
      codeRequired: 'Code required',
      codeNotMatch: 'Code doesn’t match',
    },
    banner: {
      title: 'Don’t share this code',
      description:
        'A Varo customer representative will never ask for this code.',
    },
  },
  externalAccounts: {
    navigationTitle: 'External account',
    title: 'External accounts',
    externalAccountsAndCards: 'Linked cards and accounts',
    emptyState: {
      heading: 'You haven’t linked any accounts yet',
      description: 'Linked external accounts will be shown here.',
    },
    emptyStateCards: {
      heading: 'No linked cards yet',
      description: 'Your linked external cards will show up here.',
    },
    linkAccountError:
      'We couldn’t start linking your account. Please try again.',
    linkAccountFailed:
      'We couldn’t finish linking your account. Please try again.',
    buttons: {
      linkAccount: 'Link an account',
      linkCard: 'Link a card',
    },
    cardDetails: {
      expDate: 'Expiration date',
      address: 'Debit card address',
      remove: 'Remove',
      removeCard: 'Remove card',
      noTransactions: 'Your activity will be shown here.',
      bank: 'Bank',
      recentTransactions: 'Recent Varo transactions',
      pendingTransactions: 'Pending Varo transactions',
      close: 'Close',
      cancel: 'Cancel',
      addressUpdated: 'Address updated.',
    },
    snackbar: {
      message: 'Expiration date updated.',
    },
    tabapayPartialAuth: {
      title: 'Transfer {{amount}} instead?',
      body: 'Your available balance is {{amount}}. You can transfer this amount or select another.',
    },
  },
  activationCard: {
    title: 'Activate Your Card',
    newPinTitle: 'Create PIN',
    changePinTitle: 'Change PIN',
    cardDescription: 'Enter the last 4 digits on your card.',
    dateDescription: 'Enter the expiration date.',
    pinDescription: 'What do you want your new PIN to be?',
    pinMismatched: 'PINs must match',
    confirmPinDescription: 'To confirm, re-enter your PIN you just created.',
    defaultSuccessTitle: 'Your card is activated',
    defaultSuccessMessage:
      'Set your pin so you can use your debit card at merchants that require one',
    defaultBelieveSuccessMessage:
      'Set your pin so you can use your believe card at merchants that require one',
    defaultPinSetSuccessTitle: 'Your card is activated',
    defaultPinSetSuccessMessage:
      'Your PIN has been set and you can now use your debit card anywhere Visa is accepted.',
    defaultBelievePinSetSuccessMessage:
      'Your PIN has been set and you can now use your Believe card anywhere Visa is accepted.',
    defaultDebitActivationSuccessMessage:
      'Your card has been activated and you can now use your debit card wherever Visa is accepted.',
    setPin: 'Set Pin',
    notRightNow: 'Not Right Now',
    letsGo: 'Lets Go',
    done: 'Done',
    next: 'Next',
    submit: 'Submit',
    errorTitle: 'Error!',
    errorMessage: 'Something went wrong.',
    newPinSuccessTitle: 'PIN Created',
    newPinSuccessMessage: 'PIN successfully created',
    changePinSuccessTitle: 'PIN Changed',
    changePinSuccessMessage: 'PIN successfully changed',
  },
  changePassword: {
    title: 'Change password',
    header: 'Create a new password',
    labels: {
      editDescription: 'Please enter your current password.',
      inputLabel: 'Current password',
      newPasswordToBe: 'What do you want your new password to be?',
      newPassword: 'New password',
      cnfNewPassword: 'Confirm new password',
      successChangePassword: 'Password successfully changed',
      passwordNotMatch: `Password doesn't match`,
      successfullyResend: 'OTP resent successfully',
    },
    button: {
      next: 'Next',
    },
  },
  changeEmail: {
    title: 'Change email',
    labels: {
      editDescription:
        'Enter a new email address. Keep in mind it’s what you’ll use to sign in to your Varo account.',
      inputLabel: 'Email address',
      successfullyChanged: 'Email successfully changed',
    },
    button: {
      next: 'Next',
      ok: 'Ok',
    },
  },
  changePhone: {
    title: 'Change phone number',
    labels: {
      editDescription:
        'Enter a new phone number. Keep in mind you’ll need access to it to verify your account.',
      inputLabel: 'US mobile number',
    },
    button: {
      next: 'Next',
      ok: 'Ok',
    },
    error: {
      header: 'Unable to process your request.',
      description:
        'Please contact customer support for further assistance or try again later.',
    },
  },
  phoneVerification: {
    error: {
      header: 'Unable to process your request.',
      description:
        'Please contact customer support for further assistance or try again later.',
      primaryButton: 'Contact Us',
      secondaryButton: 'Done',
    },
  },
  addressChangeDeclined: {
    header: 'Unable to process your request',
    description:
      'Please contact customer support for further assistance or try again later.',
    primaryButton: 'Contact us',
    secondaryButton: 'Done',
  },
  changePasswordSuccess: {
    title: 'Password updated',
    description: 'Logout now and use your new password to log in again.',
    button: {
      next: 'Login with new password',
    },
  },
  updateExpiryDate: {
    title: 'Expiration date',
    subtitle: 'Update the expiration date.',
    dateHint: 'MM/YY',
    buttonLabel: 'Update',
    closeButton: 'Close',
  },
  sandbox: {
    title: 'Sandbox',
  },
};
